export default __webpack_public_path__ + "static/media/Amenities.e0326062.svg";